import type { TreasuryNode, TreasurySnapshot, TreasuryWallet } from "../../backend/src/admin/treasuryTypes";
export type { TreasuryBalance, TreasuryDiagram, TreasuryFlow, TreasuryNode, TreasurySnapshot, TreasuryWallet } from "../../backend/src/admin/treasuryTypes";

export function treasuryAmount(amount: string, decimals: number): string {
  if (!/^\d+$/.test(amount) || !Number.isInteger(decimals) || decimals < 0 || decimals > 30) return "Unavailable";
  const digits = BigInt(amount).toString().padStart(decimals + 1, "0");
  const whole = decimals ? digits.slice(0, -decimals) : digits;
  const fraction = decimals ? digits.slice(-decimals).replace(/0+$/, "") : "";
  return `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}${fraction ? `.${fraction}` : ""}`;
}

export function explorerAddress(address: string, network: TreasurySnapshot["network"]): string {
  return `https://explorer.solana.com/address/${encodeURIComponent(address)}${network === "devnet" ? "?cluster=devnet" : ""}`;
}

export function nodeWallets(node: TreasuryNode, wallets: readonly TreasuryWallet[]): readonly TreasuryWallet[] {
  return wallets.filter(row => node.walletIds.includes(row.id)
    || (node.walletIds.includes("spin-treasuries") && row.id.startsWith("spin-"))
    || (node.walletIds.includes("market-owner") && row.id.startsWith("lp-owner-"))
    || (node.walletIds.includes("treasury-usdc") && row.id === "treasury-usdc-owner")
    || (node.walletIds.includes("growth-usdc") && row.id === "growth-usdc-owner")
    || (node.walletIds.includes("operations-usdc") && row.id === "operations-usdc-owner")
    || (node.walletIds.includes("gameplay") && row.id === "player-points-keeper"));
}
